
<script>
/**
 * @file 顶部导航栏
 */


import {mapGetters} from 'vuex';
export default{
    data() {
        return {
        };
    },
    created() {
        this.userInfo.token && this.$store.dispatch('getUserInfo');
    },
    methods: {
        async userLogout(){
            await this.$store.dispatch('logout');
            this.clearToken();
            this.$router.push({path: '/login'});
        },
        clearToken() {
            const tk = localStorage.getItem('tk');
            tk && localStorage.removeItem('tk');
            this.$store.commit('SET_USER_INFO', {
                token: ''
            });
        }
    },
    computed: {
        ...mapGetters(['userInfo'])
        // menu() {
        //     return menu;
        // }
    },
    watch: {
    },
    components: {
    }

};
</script>
<template>
<div id="header">
<header class="header">
    <div class="brand">
        <h2>政服通后台管理系统</h2>
    </div>
    <div class="user">
        <i class="el-icon-user-solid"></i>&nbsp;
        <span>欢迎您, {{userInfo.userName}}&nbsp; | </span>
        <el-button type="text" @click="userLogout">退出</el-button>
    </div>
</header>
</div>
</template>
<style scoped lang="stylus">
$headerHeight = 60px

#header
    background #286AB1
.header
    color white
    height $headerHeight
    display flex
    flex-direction row
    justify-content space-between
    align-items center
    h2
        padding-left 20px
        padding-right 100px
    .user
        margin-right 20px
ul
    padding 0
    margin 0
    list-style none
    li
        padding 13px 20px
        cursor pointer
        &:hover
           background #2C2A73
.active
    background #242260
</style>
